import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";
import SectionSlider from "../Reusable/SectionSlider/SectionSliderPeople";
import { sections, sectionPaths } from "../../constants/sectionDatapeople";
import GlobalPoliciesFileViewPopup from "../Reusable/Popup/GlobalPoliciesFileViewPopup";

import GPAdminFileViewPopup from "../Reusable/Popup/GPAdminFileViewPopup";
import AnnualEventUpload from "../Reusable/RiskSecurity/AnnualEventUpload";
import RecruitmentSelectionSectionUpload from "../GlobalPolicies/RecruitmentSelectionSectionUpload";

interface RecruitmentSelectionSectionProps {
  isManager?: boolean;
  isAdmin?: boolean;

}

const RecruitmentSelectionSection: React.FC<RecruitmentSelectionSectionProps> = ({ isManager, isAdmin }) => {
  const management = localStorage.getItem("management") || "Default Location Name";
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState<any>(null);
  const [selectedSectionName, setSelectedSectionName] = useState<string>("");

  const handleClosePopup = () => {
    setPopupOpen(false);
  };


  const handleViewClick = (fileData: any, sectionName: string) => {
    setSelectedFileData(fileData); // Set the file data for the popup
    setSelectedSectionName(sectionName); // Set the section name for the popup
    setPopupOpen(true); // Open the popup
  };

  const handleFileUploadSuccess = () => {
    // Handle any logic after successful file upload
    console.log("File uploaded successfully");
  };

  const breadcrumbs = [
    <Link key="1"to="/operations/management/">
      Home
    </Link>,
    <Link key="2" to="/operations/management/">
      Evidence Upload
    </Link>,
    <Link key="3" to="/operations/management/">
      People
    </Link>,
    <Typography key="4">{management}</Typography>,
  ];

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={"Recruitment & Selection"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      <Typography variant="h6" sx={{ fontWeight: '600', paddingLeft: '24px', fontSize: '16px' }}>Recruitment & Selection</Typography>
      <Typography sx={{ color: '#000', fontSize: '16px', padding: '10px 24px', pt: '5px' }}>
        Question : The center partners with universities, schools, and community groups to build a strong candidate pool. Senior leadership (band V and above) engages with these partnerships, evaluating initiatives to determine the most effective use of the budget.
      </Typography>

      <Box className="titlecardrisk" sx={{ width: '100%', padding: "24px" }}>
        {/* <Culture/> */}
        <AnnualEventUpload
          key="section3"
          sectionName="Recruitment Partners"
          payloadKey="recruitment_n_Selection"
          management={management}
          apiPath="/people/filter_recruitment_n_selection"
          apiPathUpload="/people/recruitment_n_selection"
          isManager={isManager}
          onFileUploadSuccess={handleFileUploadSuccess}
          onViewClick={handleViewClick} // Pass file data and section name to the popup
          fileTitle="Success is defined per number of events in the university where our leadership was talking about our Culture and opportunities, number of high potential candidates coming from top priority universities; GMT trainees subscriptions, etc."

        />
      </Box>

      {isManager && (
        <RecruitmentSelectionSectionUpload isManager={true} />

      )}

      {isAdmin && (
        <RecruitmentSelectionSectionUpload isAdmin={true} />
      )}



      {/* File View Popup */}
      {isPopupOpen && isManager && selectedFileData && (
        <GlobalPoliciesFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          userDetail={true}
          apiPath={`/people/recruitment_n_selection/${selectedFileData.id}`}
        />
      )}

      {isPopupOpen && isAdmin && selectedFileData && (
        <GPAdminFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          status={selectedFileData.status}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          apiPath={`/people/recruitment_n_selection/${selectedFileData.id}`} // Pass the API path for file details
          statusApiPath="/people/recruitment_n_selection_status" // Pass the API path for status updates
          reason_to_approve={selectedFileData.reason_to_approve}
          reason_to_revert={selectedFileData.reason_to_revert}
        />
      )}
    </>
  );
};

export default RecruitmentSelectionSection;